import React, { ReactNode } from "react";
import useIsLogin from "../hooks/useIsLogin";
import useErrorComponent from "../hooks/useErrorComponent";

function Access({ children }: { children: ReactNode }) {
  const { isLogin } = useIsLogin();
  const { Error401 } = useErrorComponent();
  return <>{isLogin ? children : <>{Error401}</>}</>;
}

export default Access;
